
<template>
  <div class="home">
    <div class="wrapper-content">
      <div class="container">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <!-- <div class="pt-3">
          <b-alert
            :show="dismissCountDown"
            dismissible
            fade
            variant="danger"
            @dismiss-count-down="countDownChanged"
          >Welcome To Trakop !</b-alert>
        </div>-->
        <!-- <SwitchLanguage /> -->

        <div class="slider_bx">
          <b-carousel
            id="carousel-1"
            v-model="slide"
            :interval="4000"
            controls
            indicators
            background="#ababab"
            img-width="1024"
            img-height="480"
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <!-- Text slides with image -->
            <div v-for="(img,index) in banners" :key="index">
              <b-carousel-slide :img-src="img.image" alt="banner"></b-carousel-slide>
            </div>
          </b-carousel>
        </div>

        <div class="nextOrderDetails" v-if="orderChangeDate">
          <div class="nextOrderTopbar">
            <h2>{{ $t('message.OrderDetails') }}</h2>
            <!-- <div class="orderChangesBtn">
              <a href="#">Change Order</a>
            </div>-->
          </div>
          <div class="nextOrderList">
            <ul>
              <li>
                <p>{{ $t('message.OrderchangeDate') }}</p>
                <b>{{newdate(orderChangeDate)}}</b>
              </li>
              <li>
                <p>{{ $t('message.OrderAmountBilled') }}</p>
                <b>{{currency}} {{amountBilled.toFixed(2)}}</b>
              </li>
              <li>
                <p>{{ $t('message.OderDeliverdate') }}</p>
                <b>{{nextDeliveryDate}}</b>
              </li>
            </ul>
          </div>
        </div>

        <div class="upcomingDelivery" v-if="subscribedItems=='undefined'">
          <div class="upcomingDeliveryBottom">
            <h4 class="text-center">{{ $t('message.ItemsIncluded') }}</h4>
            <VueSlickCarousel v-bind="settings">
              <div class="product_bx" v-for="(item,index) in subscribedItems" :key="index">
                <div class="items">
                  <div class="img_bx">
                    <a href="#">
                      <img :src="imageBaseUrl+item.image" alt="milk" />
                    </a>
                  </div>
                  <div class="product_cont">
                    <a href="#" class="product-name">{{item.name}}</a>
                    <div class="quantity">{{item.quantity}}</div>
                  </div>
                </div>
              </div>
            </VueSlickCarousel>
          </div>
        </div>
        <div class="driverVanDetail" v-if="driverName">
          <h4>{{ $t('message.DriverDetails') }}</h4>
          <ul>
            <li>
              <i class="fa fa-user"></i>
              {{driverName}}
            </li>
            <li>
              <a href="#" v-b-modal.map>
                <i class="fa fa-map-marker"></i>
                {{ $t('message.Location') }}
              </a>
            </li>
            <li>
              <a href="#" v-b-modal.phone>
                <i class="fa fa-phone"></i>
                {{ $t('message.Call') }}
              </a>
            </li>
          </ul>
        </div>
        <br />
        <div class="category_box panel">
          <h2>{{ $t('message.Categories') }}</h2>
          <ul id="categoryList">
            <li v-for="(item, index) in items" :key="index">
              <div v-on:click="reload(item.id,item.meta.meta_slug)" class="pointer">
                <img v-lazy="imageBaseUrl+ item.category_image" v-if="item.category_image" />
                <img v-lazy="imageBaseUrl+ logoImg" v-else />
                <h4>{{ item.name }}</h4>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <b-modal id="map" title="Driver's Location" ok-only>
      <gmap-map :center="center" :zoom="12" style="width:100%;  height: 400px;">
        <gmap-marker :position="center"></gmap-marker>
      </gmap-map>
    </b-modal>
    <b-modal id="phone" title="To Call" hide-footer>
      <h5>{{ $t('message.DriverPhone') }}: {{driverPhoneno}}</h5>
    </b-modal>
    <!-- <div ref="parentSidebar" id="parentx">
      <app-footer></app-footer>
    </div>-->
  </div>
</template>

<script>
import Vue from "vue";
import VueHelmet from "vue-helmet";
import "../../node_modules/vue-slick-carousel/dist/vue-slick-carousel.css";
import "../../node_modules/vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import VueSlickCarousel from "vue-slick-carousel";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import VueLazyload from "vue-lazyload";
import VueMeta from "vue-meta";
import moment from "moment";
import SwitchLanguage from "./SwitchLanguage.vue";
import getSymbolFromCurrency from "currency-symbol-map";
import {
  getCategories,
  getVendorBannerListing,
  getBalanceAndDeliveryInfo,
  getDeliveryManInfo,
  getVendorCurrency,
  getDomainbaseVendorInfo,
  getBalance
} from "./../services/api";
Vue.use(VueMeta);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: "giphy.gif",
  attempt: 1
});

export default {
  name: "home",

  components: {
    SwitchLanguage,
    VueSlickCarousel,
    Loading,
    VueHelmet
  },

  data() {
    return {
      list: "",
      currency: "",
      dismissSecs: 20,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      descriptionMeta: "",
      titleMeta: "",
      keywordsMeta: "",
      isLoading: false,
      fullPage: true,
      center: { lat: "", lng: "" },
      items: [],
      imageBaseUrl: "https://trakop.s3.amazonaws.com/",
      logoImg: localStorage.getItem("logoImg"),
      slide: 0,
      sliding: null,
      orderChangeDate: "",
      amountBilled: "",
      nextDeliveryDate: "",
      delivery_id: "",
      vendorId: "",
      subscribedItems: [],
      banners: [],
      driverName: "",
      driverPhoneno: "",
      settings: {
        arrows: true,
        dots: false,
        focusOnSelect: true,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        touchThreshold: 5,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          }
        ]
      }
    };
  },

  metaInfo() {
    return {
      meta: [
        { name: "description", content: this.descriptionMeta },
        {
          name: "title",
          content: this.titleMeta
        },
        {
          name: "keywords",
          content: this.keywordsMeta
        }
      ]
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     console.log("OOOOOO");
  //     next();
  //   });
  // },
  created() {
    // this.showAlert();
    // Vue.$toast.open({
    //   message: "Welcome To Trakop !",
    //   type: "info",
    //   position: "top-right",
    //   duration: 5000
    // });
    this.getVendorDetails();
    if (localStorage.getItem("token")) {
      this.getBalanceDetails();
    }
  },
  methods: {
    newdate(value) {
      if (value) {
        return moment(value).format("DD/MM/YYYY hh:mm A");
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    getBalanceDetails() {
      var requestData = {
        user_id: localStorage.getItem("userId"),
        token: localStorage.getItem("token"),
        vendor_id: localStorage.getItem("vendorId")
      };
      getBalance(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            localStorage.setItem("walletBalance", result.data.balance);
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    },
    reload(id, name) {
      // localStorage.setItem("categoryId", id);

      // let url = process.env.VUE_APP_URL + "/" + name;
      // let currentUrl = window.location.href;
      // console.log(url, "----------url");
      // console.log(currentUrl, "----------currentUrl");
      // window.parent.location = url;

      this.$router.push({
        name: "subcategory",
        params: { subcategoryname: name }
      });
    },

    getVendorDetails() {
      var requestData = {
        domain: window.location.host
      };
      this.isLoading = true;
      getDomainbaseVendorInfo(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.vendorId = result.data.data.vendor_id;
            // this.$route.meta.title = result.data.data.meta_title
            this.titleMeta = result.data.data.meta_title;
            this.descriptionMeta = result.data.data.meta_description;
            this.keywordsMeta = result.data.data.meta_keywords;
            // document
            //   .getElementById("titletag")
            //   .setAttribute("content", result.data.data.meta_title);

            // document
            //   .getElementById("descriptiontag")
            //   .setAttribute("content", result.data.data.meta_description);
            // document
            //   .getElementById("keywordstag")
            //   .setAttribute("content", result.data.data.meta_keywords);
            this.getCategoriesDetails();
            this.getBanners();
            this.getOrderInfo();
            this.getCurrency();
            this.getDeliveryInfo();
            this.isLoading = false;
          }
        })
        .catch(error => {
          this.isLoading = false;
          return;
        });
    },

    getCategoriesDetails() {
      if (!localStorage.getItem("token")) {
        var requestData = {
          user_type: "guest",
          vendor_id: this.vendorId
        };
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          vendor_id: this.vendorId
        };
      }
      this.isLoading = true;
      getCategories(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.items = result.data.allCategoryProductsList;
            this.isLoading = false;
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
            this.isLoading = false;
          }
        })
        .catch(error => {
          this.isLoading = false;
          return;
        });
    },
    getCurrency() {
      getVendorCurrency(this.vendorId)
        .then(result => {
          var currency_name = result.data.currency;

          localStorage.setItem(
            "CurrencySymbol",
            getSymbolFromCurrency(currency_name)
          );
        })
        .catch(error => {
          return;
        });
    },
    getBanners() {
      this.isLoading = true;
      getVendorBannerListing(this.vendorId)
        .then(result => {
          if (result.data.successCode === 1 || result.data.successCode === 2) {
            this.banners = result.data.bannerListing;
            this.isLoading = false;
          }
        })
        .catch(error => {
          this.isLoading = false;
          return;
        });
    },
    getOrderInfo() {
      var requestData = {
        user_id: localStorage.getItem("userId"),
        token: localStorage.getItem("token"),
        vendor_id: this.vendorId
      };

      getBalanceAndDeliveryInfo(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            // console.log("ordr", result);
            this.delivery_id = result.data.deliver_schdule_id;
            this.orderChangeDate = result.data.edit__order_time;
            this.amountBilled = result.data.subscriptionOrderTotalPrice;
            this.nextDeliveryDate =
              newdate(result.data.willDeliver) +
              " " +
              result.data.subscriptionItems[0].between;
            this.subscribedItems = result.data.subscriptionItems;
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    },
    getDeliveryInfo() {
      var requestData = {
        user_id: localStorage.getItem("userId"),
        token: localStorage.getItem("token"),
        vendor_id: this.vendorId,
        delivery_schdule_id: this.delivery_id
      };

      getDeliveryManInfo(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.driverName = result.data.driverInfo.name;
            this.driverPhoneno = result.data.driverInfo.phoneNo;
            this.center.lat = result.data.driverInfo.latitude;
            this.center.lng = result.data.driverInfo.longitude;
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    },

    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    }
  }
};
</script>
